var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.971,
    height: 44.971,
    viewBox: "0 0 44.971 44.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "users",
    d: "M13.741,23.818a8.245,8.245,0,1,1,8.245-8.245,8.245,8.245,0,0,1-8.245,8.245Zm0-12.825a4.58,4.58,0,1,0,4.58,4.58A4.58,4.58,0,0,0,13.741,10.993ZM27.482,42.139v-.916A13.741,13.741,0,1,0,0,41.223v.916a1.832,1.832,0,1,0,3.664,0v-.916a10.077,10.077,0,1,1,20.153,0v.916a1.832,1.832,0,1,0,3.664,0Zm16.489-9.161A12.825,12.825,0,0,0,22.6,23.42a1.832,1.832,0,1,0,2.444,2.73,9.161,9.161,0,0,1,15.267,6.828,1.832,1.832,0,1,0,3.664,0ZM32.062,16.489a8.245,8.245,0,1,1,8.245-8.245,8.245,8.245,0,0,1-8.245,8.245Zm0-12.825a4.58,4.58,0,1,0,4.58,4.58A4.58,4.58,0,0,0,32.062,3.664Z",
    transform: "translate(0.5 0.5)",
    stroke: "#000",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.1255ec87333c5c91c6b9725291970c0e.svg";
export { ForwardRef as ReactComponent };